/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SaveDashboardFiltersRequestBody,
  SaveDashboardFiltersRequestBody$Outbound,
  SaveDashboardFiltersRequestBody$outboundSchema,
} from "../components/savedashboardfiltersrequestbody.js";

export type SaveDashboardFiltersSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SaveDashboardFiltersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  saveDashboardFiltersRequestBody: SaveDashboardFiltersRequestBody;
};

/** @internal */
export type SaveDashboardFiltersSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SaveDashboardFiltersSecurity$outboundSchema: z.ZodMiniType<
  SaveDashboardFiltersSecurity$Outbound,
  SaveDashboardFiltersSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function saveDashboardFiltersSecurityToJSON(
  saveDashboardFiltersSecurity: SaveDashboardFiltersSecurity,
): string {
  return JSON.stringify(
    SaveDashboardFiltersSecurity$outboundSchema.parse(
      saveDashboardFiltersSecurity,
    ),
  );
}

/** @internal */
export type SaveDashboardFiltersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SaveDashboardFiltersRequestBody: SaveDashboardFiltersRequestBody$Outbound;
};

/** @internal */
export const SaveDashboardFiltersRequest$outboundSchema: z.ZodMiniType<
  SaveDashboardFiltersRequest$Outbound,
  SaveDashboardFiltersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    saveDashboardFiltersRequestBody:
      SaveDashboardFiltersRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      saveDashboardFiltersRequestBody: "SaveDashboardFiltersRequestBody",
    });
  }),
);

export function saveDashboardFiltersRequestToJSON(
  saveDashboardFiltersRequest: SaveDashboardFiltersRequest,
): string {
  return JSON.stringify(
    SaveDashboardFiltersRequest$outboundSchema.parse(
      saveDashboardFiltersRequest,
    ),
  );
}
